export const GEOCODE_SET_SEARCH_TERM = 'GEOCODE_SET_SEARCH_TERM';
export const GEOCODE_SET_SEARCH_RESULTS = 'GEOCODE_SET_SEARCH_RESULTS';
export const GEOCODE_RESET = 'GEOCODE_RESET';

export const setSearchTerm = (searchTerm)=>{
	return {
		type: GEOCODE_SET_SEARCH_TERM,
		payload: {searchTerm}
	}
}


// WEBPACK FOOTER //
// ./src/shared/geocode/geocodeActions.js